module.exports = __webpack_public_path__ + "bq.13e7d9ad7eb788768dcd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bq.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bq.svg
// module chunks = styles